import { render } from "./AddNewPaymentTerm.vue?vue&type=template&id=e3251c98"
import script from "./AddNewPaymentTerm.vue?vue&type=script&lang=js"
export * from "./AddNewPaymentTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__